import { PollOptionItem } from 'types';

export const getEmptyField = (fields: PollOptionItem[]) => {
  const emptyField = fields.find(({ value }) => !value);
  const emptyFieldIndex = (emptyField && fields.indexOf(emptyField)) ?? -1;
  const isEmptyField = emptyFieldIndex >= 0 && !fields[emptyFieldIndex].value;

  return { isEmptyField, emptyFieldIndex };
};
